import request from '@/utils/request'

export function fetchList() {
  return request({
    url: '/api/management/users',
    method: 'get'
  })
}

export function createUser(data) {
  return request({
    url: '/api/management/users',
    method: 'post',
    data
  })
}

export function updateUser(id, data) {
  // Make sure not to send the password if it's empty
  if (data.password === '') {
    delete data.password
  }
  return request({
    url: `/api/management/users/${id}`,
    method: 'put',
    data
  })
}

export function deleteUser(id) {
  return request({
    url: `/api/management/users/${id}`,
    method: 'delete'
  })
}
